export default {
  listTitle: 'Кошельки',
  detailTitle: 'Кошелёк',
  empty: 'Кошельки не найдены',
  columns: {
    id: 'ID',
    details: 'Подробно',
    type: 'Тип',
    description: 'Описание',
    userId: 'User ID',
    accounts: 'Счета',
    createdAt: 'Создан',
    updatedAt: 'Обновлён',
  },
  types: {
    user: 'Пользователь',
    restorant: 'Ресторан',
    courier: 'Курьер',
    service: 'Сервис',
    fund: 'Фонд',
    partner: 'Партнёр',
    freeze: 'Заморозка',
    virtual: 'Виртуальный',
  },
  filters: {
    walletIdPlaceholder: 'ID кошелька',
    userIdPlaceholder: 'User ID',
    typeAll: 'Все типы',
    reset: 'Сбросить',
  },
  actions: {
    openDetails: 'Подробнее',
    openDetailsNewWindow: 'Открыть в новом окне',
    openFilteredList: 'Открыть список с фильтром',
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
  },
  accountsEmpty: 'Счетов нет',
  currency: 'Валюта',
  errors: {
    loadList: 'Не удалось загрузить кошельки',
    loadDetail: 'Не удалось загрузить кошелёк',
  },
}
